module.exports = ".moreRoundCon {\n    height: 100%;\n    overflow: hidden;\n    color: rgb(115, 115, 118);\n  }\n  \n  .moreRoundOptList {\n    height: 50px;\n    width: 100%;\n    border-bottom: 1px solid rgb(221, 221, 222);\n    cursor: pointer;\n  }\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/popups/bookmoreoptions/bookmoreoptions.component.css
// module id = ./src/app/bookShared/popups/bookmoreoptions/bookmoreoptions.component.css
// module chunks = main